import React, { useState, useMemo } from "react";
import Select from "react-select";
import { Row, Col } from "styled-bootstrap-grid";
import { Button } from "react-bootstrap";
import Seguimiento_individual from "../seguimiento_forms/form_seguimiento_individual";
import Seguimiento_individual_v2 from "../seguimiento_forms/form_seguimiento_individual_v2";
import Seguimiento_individual_v3 from "../seguimiento_forms/form_seguimiento_individual_v3";
import Seguimiento_individual_v3_1 from "../seguimiento_forms/form_seguimiento_individual_v3_1";
import { useEffect } from "react";
import axios from "axios";
import Selector from "../../components/ficha_estudiante/selector";
import Info_registros from "./info_registros";
import Programas_academicos from "./programas_academicos";
import Inasistencia from "../seguimiento_forms/form_inasistencia";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { differenceInYears } from "date-fns";
import { parseISO } from "date-fns";
import Modal from "react-bootstrap/Modal";
import GraphComponent from "./trayectoria.jsx";
import {
  desencriptar,
  decryptTokenFromSessionStorage,
  desencriptarInt,
  encriptarInt,
} from "../../modulos/utilidades_seguridad/utilidades_seguridad.jsx";
import { useRef } from "react";

import Asiste_academico from "../../service/ficha_estudiante_consulta_academico.js";

const Info_basica = (props) => {
  // console.log(props);
  const config = {
    headers: {
      Authorization: "Bearer " + decryptTokenFromSessionStorage(),
    },
  };

  const config2 = {
    Authorization: "Bearer " + decryptTokenFromSessionStorage(),
  };

  const [loading, setLoading2] = useState(false);
  const [fechas, setFechas] = useState([]);
  const [riesgos, setRiesgos] = useState({});

  const fechaReferenciaV3_1 = new Date("2026-07-30"); // Fecha desde que corre la versión 3.1 de la ficha
  const fechaActual = new Date();

  const traer_graficos = () => {
    setLoading2(true);
    const paramsget = {
      id_sede: desencriptarInt(sessionStorage.getItem("sede_id")),
    };
    const url_axios =
      `${process.env.REACT_APP_API_URL}/seguimiento/seguimiento_individual/` +
      state.id_usuario +
      "/trayectoria/";
    axios({
      // Endpoint to send files
      url: url_axios,
      params: paramsget,
      method: "GET",
      headers: config2,
    })
      .then((response) => {
        setFechas(response.data[0].fechas);
        const riesgos = response.data.slice(1);
        const riesgosObj = {};

        riesgos.forEach((riesgo) => {
          const [key] = Object.keys(riesgo);
          const [values] = Object.values(riesgo);
          riesgosObj[key] = values;
        });

        setRiesgos(riesgosObj);
        // document.getElementsByName("loading_data")[0].style.visibility =
        //   "hidden";
      })
      .catch((error) => {
        console.error("Error al obtener los riesgos:", error);
      })
      .finally(() => {
        setLoading2(false);
        handleShow();
      });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  //ids de los tabs para cuando los requieran abrir apenas cargue la pestaña     General :1, Sociedu:2, Academico:3, Geografico:4

  const [switchChecked, setChecked] = useState(false);
  const handleChange = () => setChecked(!switchChecked);

  const [show, setShow] = useState(false);
  const handleModal = () => setShow(true);
  const handleClose = () => setShow(false);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow = () => setShow2(true);

  const [showIn, setShowIn] = useState(false);
  const handleModalIn = () => setShowIn(true);
  const handleCloseIn = () => setShowIn(false);

  const datos_option_user = useMemo(() => {
    return (props.data_user || []).map((user, i) => ({
      value: user.id,
      label: `${user.cod_univalle} ${user.nombre} ${user.apellido}`,
      id: i,
    }));
  }, [props.data_user]);
  //console.log("opciones:", datos_option_user);

  const [isLoading, setIsLoading] = useState(true);

  const userRole = desencriptar(sessionStorage.getItem("rol"));

  const bandera_option_user = useRef(true);
  const [state, set_state] = useState({
    actualizar: 0,
    total_datos_estudiante_seleccionado: [],
    editar: false,
    usuario: "",
    data_user: [],
    data_rol: [],
    total_datos_estudiantes: [],
    tab_abierto: "",
    seleccionado: "",
    ya_selecciono_automatico: true,
    asistencia_academica: [],

    id_usuario: "",
    nombres: "",
    apellidos: "",
    codigo: "",
    tipo_doc: "",
    cedula: "",
    correo: "",
    telefono: 3122131542,
    celular: 0,
    ptogramas: [],
    monitor: [],
    practicante: [],
    profesional: [],
    nombre_cohorte: "",

    nueva_cedula: "",
    edad: "",
  });
  useEffect(() => {
    if (state.total_datos_estudiantes["nombre"] && isLoading) {
      set_state({
        ...state,
        seleccionado: state.total_datos_estudiantes["id"],
        id_usuario: state.total_datos_estudiantes["id"],
        nombres: state.total_datos_estudiantes["nombre"],
        apellidos: state.total_datos_estudiantes["apellido"],
        codigo: state.total_datos_estudiantes["cod_univalle"],
        correo: state.total_datos_estudiantes["email"],
        tipo_doc: state.total_datos_estudiantes["tipo_doc"],
        cedula: state.total_datos_estudiantes["num_doc"],
        telefono: state.total_datos_estudiantes["telefono_res"],
        celular: state.total_datos_estudiantes["celular"],
        programas: state.total_datos_estudiantes["programas"],
        monitor: state.total_datos_estudiantes["info_monitor"],
        practicante: state.total_datos_estudiantes["practicante"],
        profesional: state.total_datos_estudiantes["profesional"],
        nombre_cohorte: state.total_datos_estudiantes["nombre_cohorte"],
        total_datos_estudiante_seleccionado: state.total_datos_estudiantes,
      });
    }
  }, [state.total_datos_estudiantes]);

  const [selectedOption, setSelectedOption] = useState(null);

  const { id } = useParams();

  function nuevo_actualizar(name) {
    set_state({
      ...state,
      actualizar: state.actualizar + name,
    });
  }

  const [url_estudiante, setUrl] = useState("");

  useEffect(() => {
    // Evita ejecutar hasta tener listado y un id de estudiante valido
    if (!props.data_user?.length) return;
    if (!url_estudiante || url_estudiante === "sin_seleccion") return;
    handle_users();
  }, [props.data_user, url_estudiante]);

  useEffect(() => {
    // console.log("TRY # N");
    const currentUrl = desencriptar(sessionStorage.getItem("path"));
    const subUrl = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);
    // console.log(subUrl);
    setUrl(subUrl);
    // console.log(url_estudiante);
  }, []);

  const fetchData = async (index) => {
    try {
      const paramsget = {
        id_sede: desencriptarInt(sessionStorage.getItem("sede_id")),
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/usuario_rol/estudiante/` +
          state.data_user[index]["id"] +
          "/datos_ficha_estudiante/",
        config,
        { paramsget },
      );
      // console.log(response.data);
      state.total_datos_estudiantes.push(response.data);
      // document.getElementsByName("loading_data")[0].style.visibility = "hidden";
    } catch (error) {
      fetchData(index);
    }
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id_parametros = searchParams.get("id");

  const [estudiante_no_lista, setEstudiante_no_lista] = useState(false);
  // var estudiante_no_lista = false;
  const handle_users = (e) => {
    if (bandera_option_user.current !== true) return;
    if (!props.data_user?.length) return;
    if (!url_estudiante || url_estudiante === "sin_seleccion") return;

    const existeEnLista = props.data_user.some(
      (estudiante) => String(estudiante.id) === String(url_estudiante),
    );
    setEstudiante_no_lista(!existeEnLista);

    const paramsget = {
      id_sede: desencriptarInt(sessionStorage.getItem("sede_id")),
    };

    if (existeEnLista && state.ya_selecciono_automatico) {
      const datoSeleccionado = datos_option_user.find(
        (dato) => String(dato.value) === String(url_estudiante),
      );
      if (datoSeleccionado) {
        setSelectedOption(datoSeleccionado);
        const url_axios =
          `${process.env.REACT_APP_API_URL}/usuario_rol/estudiante/` +
          datoSeleccionado.value +
          "/datos_ficha_estudiante/";
        axios({
          url: url_axios,
          params: paramsget,
          method: "GET",
          headers: config2,
        })
          .then((respuesta) => {
            set_state((prev) => ({
              ...prev,
              total_datos_estudiantes: respuesta.data,
              tab_abierto: 3,
              ya_selecciono_automatico: false,
            }));
          })
          .catch((err) => {
            // console.log("no tomo el dato");
          });
      }
    }

    if (!existeEnLista) {
      const url_axios =
        `${process.env.REACT_APP_API_URL}/usuario_rol/estudiante/` +
        url_estudiante +
        "/datos_ficha_estudiante/";
      axios({
        url: url_axios,
        params: paramsget,
        method: "GET",
        headers: config2,
      })
        .then((respuesta) => {
          set_state((prev) => ({
            ...prev,
            total_datos_estudiantes: respuesta.data,
            tab_abierto: 3,
            ya_selecciono_automatico: false,
          }));

          const dato = {
            value: respuesta.data["id"],
            label:
              respuesta.data["cod_univalle"] +
              " " +
              respuesta.data["nombre"] +
              " " +
              respuesta.data["apellido"],
            id: props.data_user["length"] + 1,
          };
          setSelectedOption(dato);
        })
        .catch((err) => {
          // console.log("no tomo el dato");
        });
    }

    bandera_option_user.current = false;
  };

  const handle_option_user = (e) => {
    //console.log("seleccionaste:", e);
    const paramsget = {
      id_sede: desencriptarInt(sessionStorage.getItem("sede_id")),
    };
    const id_estudiante_encriptada = encriptarInt(e.value);
    sessionStorage.setItem(
      "id_estudiante_seleccionado",
      id_estudiante_encriptada,
    );
    const url_axios =
      `${process.env.REACT_APP_API_URL}/usuario_rol/estudiante/` +
      e.value +
      "/datos_ficha_estudiante/";
    axios({
      url: url_axios,
      params: paramsget,
      method: "GET",
      headers: config2,
    })
      .then((respuesta) => {
        // document.getElementsByName("loading_data")[0].style.visibility =
        //   "hidden";

        const json = respuesta.data;

        // Obtener la fecha de nacimiento del JSON
        const fechaNacimiento = parseISO(json.fecha_nac);

        // Obtener la fecha actual
        const fechaActual = new Date();

        // Calcular la diferencia de años entre la fecha actual y la fecha de nacimiento
        const edad = differenceInYears(fechaActual, fechaNacimiento);

        // Actualizar el estado con los datos y la edad calculada
        set_state({
          ...state,
          total_datos_estudiantes: {
            ...json,
          },
          edad: edad,
        });
      })
      .catch((err) => {
        // console.log("Error al obtener el dato del estudiante: " + err);
      });

    setSelectedOption(e);
  };

  const handleWhatsapp = (e) => {
    const celular_numerico = parseInt(state.celular);
    if (celular_numerico) {
      const url = `https://api.whatsapp.com/send?phone=${celular_numerico}`;
      window.open(url, "_blank");
    } else {
      alert("problema con el celular_numerico");
    }
  };
  // // console.log(state.total_datos_estudiante_seleccionado);

  const asistenciaAcademicos = async () => {
    const response = await Asiste_academico.ficha_estudiante_consulta_academico(
      {
        id_estudiante: state.total_datos_estudiante_seleccionado.id,
        semestre_actual: desencriptar(
          sessionStorage.getItem("semestre_actual"),
        ),
        id_sede: desencriptarInt(sessionStorage.getItem("sede_id")),
      },
    );
    set_state({
      ...state,
      asistencia_academica: response,
    });
  };

  // Consulta si el estudiante asiste a monitorias academicas
  useEffect(() => {
    if (state?.total_datos_estudiante_seleccionado?.id) {
      asistenciaAcademicos();
    }
  }, [state?.total_datos_estudiante_seleccionado?.id]);

  // Renderizado del componente para visualizar seguimientos
  return (
    <Row className="row_prueba">
      {fechaActual >= fechaReferenciaV3_1 ? (
        <Seguimiento_individual_v3_1
          estudiante_seleccionado={state.seleccionado}
          recarga_ficha_estudiante={true}
          show={show}
          onHide={handleClose}
          handleClose={handleClose}
          handleModalIn={handleModalIn}
          size="lg"
        />
      ) : (
        <Seguimiento_individual_v3
          estudiante_seleccionado={state.seleccionado}
          recarga_ficha_estudiante={true}
          show={show}
          onHide={handleClose}
          handleClose={handleClose}
          handleModalIn={handleModalIn}
          size="lg"
        />
      )}

      <Inasistencia
        estudiante_seleccionado={state.seleccionado}
        recarga_ficha_estudiante={true}
        show={showIn}
        onHide={handleCloseIn}
        handleCloseIn={handleCloseIn}
        handleModal={handleModal}
        size="lg"
      />
      {/* {!loading && fechas.length > 0 && Object.keys(riesgos).length > 0 && (
          <GraphComponent fechas={fechas} riesgos={riesgos} />
        )} */}
      {/*<li >{JSON.stringify(state.total_datos_estudiantes)}</li>*/}

      <Col xs={"12"} lg={"9"}>
        <div class="d-none d-md-block">
          <Row className="info_basica_borde">
            <Col className="col1" xs={"12"} md={"9"}>
              <Row>
                <Select
                  className="bold_select"
                  options={datos_option_user}
                  // onMenuOpen={handle_users}
                  onChange={handle_option_user}
                  value={selectedOption}
                />
              </Row>
              <Row className="rowJustFlex">
                <Col className="colInfo1" xs={"12"}>
                  <Row className="infoRow1">
                    <Col md={"12"}>
                      {state.seleccionado === "" ? (
                        <Row className="info">
                          <Col className="info_texto" xs={"5"} md={"3"}>
                            <h4 className="texto_mas_pequeño">
                              {state.tipo_doc}
                              cédula
                            </h4>
                          </Col>
                          <Col className="info_texto" md={"5"}>
                            <h4 className="texto_mas_pequeño">correo</h4>
                          </Col>
                          <Col className="info_texto" xs={"3"} md={"2"}>
                            <h4 className="texto_mas_pequeño">edad</h4>
                          </Col>
                          <Col className="info_texto" xs={"3"} md={"2"}>
                            <h4 className="texto_mas_pequeño">Teléfono</h4>
                          </Col>
                        </Row>
                      ) : (
                        <Row className="info">
                          <Col className="info_texto" xs={"12"} md={"3"}>
                            <h4 className="texto_mas_pequeño">
                              {state.tipo_doc} {state.cedula}
                            </h4>
                          </Col>
                          <Col className="info_texto" xs={"12"} md={"5"}>
                            <h4 className="texto_mas_pequeño">
                              <a href={`mailto:${state.correo}`}>
                                {state.correo}
                              </a>
                            </h4>
                          </Col>
                          <Col className="info_texto" xs={"12"} md={"2"}>
                            <h4 className="texto_mas_pequeño">
                              {state.edad} años
                            </h4>
                          </Col>
                          <Col className="info_texto" xs={"12"} md={"2"}>
                            <h4 className="texto_mas_pequeño">
                              {state.celular}
                            </h4>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                  {state.seleccionado === "" ? (
                    <Row className="infoRow2">
                      <Col xs={"12"} md={"9"}>
                        <Row>
                          <h4 className="bold">Programas académicos</h4>
                        </Row>
                        <Row>
                          <label className="info_programa_academico_egresado">
                            Egresado
                          </label>
                          <label className="info_programa_academico_en_curso">
                            En curso
                          </label>
                          <label className="info_programa_academico_desertor">
                            Desertor
                          </label>
                        </Row>
                        <Row className="infoRow23_inactivo">
                          <Col xs={"6"} md={"6"}>
                            <h4 className="texto_pequeño">{state.codigo}</h4>
                          </Col>
                        </Row>
                        <Row>
                          <h4 className="texto_mas_pequeño">
                            <br />
                            Profesional:
                            <br />
                            Practicante:
                            <br />
                            Monitor:
                            <br />
                            Ultima actualización:
                            <br />
                          </h4>
                        </Row>
                        <Row>
                          <br />
                          Es academico?
                        </Row>
                        <Row md={"5"}>
                          {/* Tratamiento de Datos */}
                          <Col
                            md={"1"}
                            className={"alert_item alert_item-datos"}
                            title="Tratamiento de datos"
                          >
                            <i class="bi bi-check2-square"></i>
                          </Col>
                          {/* Encuesta Admitidos */}
                          <Col
                            md={"1"}
                            className={"alert_item alert_item-admitidos"}
                            title="Encuesta de Admitidos"
                          >
                            <i class="bi bi-card-checklist"></i>
                          </Col>
                          {/* FIcha Semana Anterior */}
                          <Col
                            md={"1"}
                            className={"alert_item alert_item-semana"}
                            title="Ficha de la Semana Anterior"
                          >
                            {" "}
                            <i class="bi bi-calendar2-check"></i>
                          </Col>
                        </Row>
                      </Col>

                      <div class="d-none d-md-block col-md-3">
                        <Col xs={"12"} md={"12"} className="col_2017">
                          <button className="boton_editar_info_basica">
                            <i>TRAYECTORIA</i>
                          </button>
                          <button
                            className="boton_editar_info_basica"
                            onClick={handleWhatsapp}
                          >
                            <i class="bi bi-whatsapp"> + 57 {state.celular}</i>
                          </button>
                          <Row className="texto_estatico">
                            <h4 className="texto_mas_pequeño">
                              {state.nombre_cohorte} <br />
                            </h4>
                          </Row>
                        </Col>
                      </div>
                    </Row>
                  ) : (
                    <Row className="infoRow2">
                      <Col md={"9"}>
                        <Row>
                          <h4 className="texto_pequeño">
                            Programas académicos{" "}
                          </h4>
                        </Row>
                        <Row>
                          <label className="info_programa_academico_egresado">
                            Egresado
                          </label>
                          <label className="info_programa_academico_en_curso">
                            En curso
                          </label>
                          <label className="info_programa_academico_desertor">
                            Desertor
                          </label>
                        </Row>
                        {state.programas.map((item, index) => (
                          <Programas_academicos
                            rolUsuario={props.rolUsuario}
                            item={item}
                          />
                        ))}
                        <Row>
                          <h4 className="texto_mas_pequeño">
                            <br />
                            Profesional: {state.profesional.first_name}{" "}
                            {state.profesional.last_name}
                            <br />
                            Practicante: {state.practicante.first_name}{" "}
                            {state.practicante.last_name}
                            <br />
                            Monitor: {state.monitor.first_name}{" "}
                            {state.monitor.last_name}
                            <br />
                            Ultima actualización:{" "}
                            {state.total_datos_estudiantes.ult_modificacion}
                            <br />
                          </h4>
                        </Row>
                        <Row>¿Es académico?</Row>
                        <Row md={"2"}>
                          <Col md={"2"}>
                            <input
                              type="checkbox"
                              readOnly
                              checked={
                                state?.total_datos_estudiante_seleccionado
                                  ?.es_academico == true
                                  ? true
                                  : false
                              }
                            ></input>
                            {"Sí"}
                          </Col>
                          <Col md={"2"}>
                            <input
                              type="checkbox"
                              readOnly
                              checked={
                                state?.total_datos_estudiante_seleccionado
                                  ?.es_academico == false
                                  ? true
                                  : false
                              }
                            ></input>
                            {"No"}
                          </Col>
                        </Row>
                        {state?.total_datos_estudiante_seleccionado
                          ?.es_academico == true ? (
                          <Col>
                            <Row>
                              <Col md={"6"}>Asiste en semestre actual </Col>
                              <Col md={"1"}>
                                {state?.asistencia_academica[0]
                                  ?.asiste_monitoria == true
                                  ? "Sí"
                                  : "NO"}
                              </Col>
                            </Row>
                            <Row>
                              <Col md={"6"}> Nombre de la monitoria</Col>
                              <Col md={"6"}>
                                {state?.asistencia_academica[0]
                                  ?.nombre_monitoria[0]
                                  ? state?.asistencia_academica[0]?.nombre_monitoria.map(
                                      (monitoria, index) => (
                                        <div key={index}>
                                          {monitoria.nombre}
                                        </div>
                                      ),
                                    )
                                  : "N/A"}
                              </Col>
                            </Row>
                            <Row>
                              <Col md={"6"}>Cantidad de asistenicas</Col>
                              <Col md={"1"}>
                                {
                                  state?.asistencia_academica[0]
                                    ?.cantidad_asistencias
                                }
                              </Col>
                            </Row>
                            <Row>
                              <Col md={"6"}>Fecha de la última asistencia</Col>
                              <Col md={"3"}>
                                {state?.asistencia_academica[0]
                                  ?.fecha_ult_asistencia
                                  ? state?.asistencia_academica[0]
                                      ?.fecha_ult_asistencia
                                  : "N/A"}
                              </Col>
                            </Row>
                          </Col>
                        ) : (
                          <></>
                        )}
                        <Row md={"5"}>
                          {/* Tratamiento de Datos */}
                          <Col
                            md={"1"}
                            className={"alert_item alert_item-datos"}
                          >
                            <a
                              href="https://sistemaases.univalle.edu.co/U2FsdGVkX18hjszpddLoSgU/HywzCP8D13edFaHOV+PmxYYqsxUx7dICZxdkz/bz"
                              target="_blank"
                            >
                              <i
                                class="bi bi-check2-square"
                                style={
                                  state.total_datos_estudiante_seleccionado
                                    .firma_tratamiento_datos == "SIN FIRMAR" ||
                                  state.total_datos_estudiante_seleccionado
                                    .firma_tratamiento_datos ===
                                    "FIRMA INEXISTENTE"
                                    ? { color: "red" }
                                    : state.total_datos_estudiante_seleccionado
                                          .firma_tratamiento_datos ==
                                        "NO AUTORIZA"
                                      ? { color: "orange" }
                                      : state
                                            .total_datos_estudiante_seleccionado
                                            .firma_tratamiento_datos ==
                                          "AUTORIZA"
                                        ? { color: " #41ae1b" }
                                        : { color: " #AAB5A6" }
                                }
                                title={
                                  state.total_datos_estudiante_seleccionado
                                    .firma_tratamiento_datos === "SIN FIRMAR" ||
                                  state.total_datos_estudiante_seleccionado
                                    .firma_tratamiento_datos ===
                                    "FIRMA INEXISTENTE"
                                    ? "Tratamiento de datos sin firmar"
                                    : state.total_datos_estudiante_seleccionado
                                          .firma_tratamiento_datos ===
                                        "NO AUTORIZA"
                                      ? "Tratamiento de datos firmado, sin autorizar"
                                      : state
                                            .total_datos_estudiante_seleccionado
                                            .firma_tratamiento_datos ===
                                          "AUTORIZA"
                                        ? "Tratamiento de datos autorizado"
                                        : "Estado del tratamiento de datos"
                                }
                              ></i>
                            </a>
                          </Col>
                          {/* Encuesta Admitidos */}
                          <Col
                            md={"1"}
                            className={"alert_item alert_item-admitidos"}
                          >
                            <a
                              href="https://encuestaadmitidos.univalle.edu.co/"
                              target="_blank"
                            >
                              <i
                                class="bi bi-card-checklist"
                                style={
                                  state.total_datos_estudiante_seleccionado
                                    .encuesta_admitido == false
                                    ? { color: "red" }
                                    : { color: " #AAB5A6" }
                                }
                                title="Encuesta de Admitidos sin Diligenciar"
                              ></i>
                            </a>
                          </Col>
                          {/* FIcha Semana Anterior */}
                          <Col
                            md={"1"}
                            className={"alert_item alert_item-semana"}
                          >
                            {" "}
                            <i
                              class="bi bi-calendar2-check"
                              style={
                                state.total_datos_estudiante_seleccionado
                                  .fecha_seguimiento == "FICHA FALTANTE"
                                  ? { color: "red" }
                                  : { color: " #AAB5A6" }
                              }
                              title="Ficha de la Semana Anterior sin Registrar"
                            ></i>
                          </Col>
                        </Row>
                      </Col>

                      <div class="d-none d-md-block col-md-3">
                        <Col xs={"12"} md={"12"} className="col_2017">
                          <button
                            className="boton_editar_info_basica"
                            onClick={traer_graficos}
                          >
                            <i>TRAYECTORIA</i>
                          </button>
                          <button
                            className="boton_editar_info_basica"
                            onClick={handleWhatsapp}
                          >
                            <i class="bi bi-whatsapp"> + 57 {state.celular}</i>
                          </button>
                          <Row className="texto_estatico">
                            <h4 className="texto_mas_pequeño">
                              {state.nombre_cohorte}
                              <br />
                            </h4>
                          </Row>
                        </Col>
                      </div>
                    </Row>
                  )}
                </Col>
              </Row>
            </Col>
            {state.seleccionado === "" ? (
              <Col xs={"12"} md={"3"}>
                <Row className="col3">
                  <i class="bi bi-person-fill"></i>
                </Row>
              </Col>
            ) : (
              <Col xs={"12"} md={"3"}>
                <Row className="col3">
                  <i class="bi bi-person-fill"></i>

                  <img src={"./imag1.jpg"}></img>
                </Row>
              </Col>
            )}
          </Row>
        </div>

        <div class="d-block d-md-none">
          <Row className="info_basica_borde_pequeño">
            <Select
              className="bold_select_pequeño"
              options={datos_option_user}
              // onMenuOpen={handle_users}
              onChange={handle_option_user}
              value={selectedOption}
            />
            {state.seleccionado === "" ? (
              <Col xs={"12"} sm={"12"}>
                <Row className="primera_row_pequeña">
                  <Col xs={"5"} sm={"4"}>
                    <Row className="col3_pequeño">
                      <i class="bi bi-person-fill"></i>
                    </Row>
                  </Col>

                  <Col xs={"7"} sm={"4"}>
                    <Row className="botones_info_basica_pequeña">
                      <button
                        className="boton_editar_info_basica"
                        onClick={handleWhatsapp}
                      >
                        <i class="bi bi-whatsapp"> + 57 {state.celular}</i>
                      </button>
                    </Row>
                    <Row className="texto_estatico_pequeño">
                      <h4 className="texto_mas_pequeño">
                        Condición de excepción
                      </h4>
                      <h4 className="texto_mas_pequeño"></h4>
                    </Row>
                    <Row className="botones_info_basica_pequeña">
                      <button
                        className="boton_editar_info_basica"
                        onClick={traer_graficos}
                      >
                        <i>TRAYECTORIA</i>
                      </button>
                    </Row>
                  </Col>
                  {(userRole === "super_ases" ||
                    userRole === "sistemas" ||
                    userRole === "socioeducativo_reg" ||
                    userRole === "socioeducativo" ||
                    userRole === "profesional" ||
                    userRole === "practicante" ||
                    userRole === "monitor") && (
                    <Button
                      className="boton_nuevo_registro_pequeño"
                      onClick={handleModal}
                    >
                      NUEVO SEGUIMIENTO
                    </Button>
                  )}
                </Row>
              </Col>
            ) : (
              <Col xs={"12"} sm={"12"}>
                <Row className="primera_row_pequeña">
                  <Col xs={"5"} sm={"4"}>
                    <Row className="col3_pequeño">
                      <i class="bi bi-person-fill"></i>
                      <img src={"./imag1.jpg"}></img>
                    </Row>
                  </Col>

                  <Col xs={"7"} sm={"4"}>
                    <Row className="botones_info_basica_pequeña">
                      <button className="boton_editar_info_basica">
                        <i class="bi bi-whatsapp"> + 57 {state.celular}</i>
                      </button>
                    </Row>
                    <Row className="texto_estatico_pequeño">
                      <h4 className="texto_mas_pequeño">
                        Condición de excepción
                      </h4>
                      <h4 className="texto_mas_pequeño"></h4>
                    </Row>
                    <Row className="botones_info_basica_pequeña">
                      <button
                        className="boton_editar_info_basica"
                        onClick={traer_graficos}
                      >
                        <i>TRAYECTORIA</i>
                      </button>
                    </Row>
                  </Col>
                  {(userRole === "super_ases" ||
                    userRole === "sistemas" ||
                    userRole === "socioeducativo_reg" ||
                    userRole === "socioeducativo" ||
                    userRole === "profesional" ||
                    userRole === "practicante" ||
                    userRole === "monitor") && (
                    <Button
                      className="boton_nuevo_registro_pequeño"
                      onClick={handleModal}
                    >
                      NUEVO SEGUIMIENTO
                    </Button>
                  )}
                </Row>
              </Col>
            )}
            <Col className="col1" xs={"12"} md={"9"}>
              <Row className="rowJustFlex">
                <Col className="colInfo1" xs={"12"}>
                  {state.seleccionado === "" ? (
                    <Row className="info_pequeño">
                      <Col className="info_texto_pequeño" md={"12"}>
                        <h4 className="texto_mas_pequeño">correo</h4>
                      </Col>
                      <Col
                        xs={"5"}
                        sm={"1"}
                        className="info_texto_cedula_pequeño"
                        md={"2"}
                      >
                        <h4 className="texto_mas_pequeño"> cédula</h4>
                      </Col>
                      <Col className="info_texto" xs={"3"} md={"12"}>
                        <h4 className="texto_mas_pequeño">edad</h4>
                      </Col>
                      <Col className="info_texto" xs={"3"} md={"2"}>
                        <h4 className="texto_mas_pequeño">teléfono</h4>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="info_pequeño">
                      <Col className="info_texto_pequeño" xs={"12"} md={"12"}>
                        <h4 className="texto_mas_pequeño">
                          <a href={`mailto:${state.correo}`}>{state.correo}</a>
                        </h4>
                      </Col>
                      <Col
                        xs={"5"}
                        sm={"1"}
                        className="info_texto_cedula_pequeño"
                      >
                        <h4 className="texto_mas_pequeño">
                          {state.tipo_doc}
                          {state.cedula}
                        </h4>
                      </Col>
                      <Col className="info_texto" xs={"3"} md={"2"}>
                        <h4 className="texto_mas_pequeño">{state.edad} años</h4>
                      </Col>
                      <Col className="info_texto" xs={"3"} md={"2"}>
                        <h4 className="texto_mas_pequeño">{state.celular}</h4>
                      </Col>
                    </Row>
                  )}
                  <Row className="ficha_footer_pequeña">
                    <Col xs={"12"} className="texto_estatico">
                      <h4 className="texto_mas_pequeño">Monitor</h4>
                    </Col>
                    <Col xs={"6"} className="texto_estatico">
                      <h4 className="texto_mas_pequeño">Profesional</h4>
                    </Col>
                    <Col xs={"6"} className="texto_estatico">
                      <h4 className="texto_mas_pequeño">Practicante</h4>
                    </Col>
                  </Row>
                  {state.seleccionado === "" ? (
                    <Row className="infoRow2_pequeño">
                      <Col xs={"12"} md={"9"}>
                        <Row className="texto_estatico">
                          <h4 className="bold">Programas académicos </h4>
                        </Row>
                        <Row className="infoRow23_inactivo">
                          <Col xs={"6"} md={"6"}>
                            <h4 className="texto_pequeño">{state.codigo} </h4>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="infoRow2_pequeño">
                      <Col xs={"12"} md={"9"}>
                        <Row className="texto_estatico">
                          <h4 className="texto_pequeño">
                            Programas académicos{" "}
                          </h4>
                        </Row>
                        {state.programas.map((item, index) => (
                          <Programas_academicos
                            rolUsuario={props.rolUsuario}
                            item={item}
                          />
                        ))}
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <div class="d-none d-md-block col-12">
          <Row>
            <Selector
              id={state.id_usuario}
              rolUsuario={props.rolUsuario}
              datos={state.total_datos_estudiante_seleccionado}
              seleccionado={state.seleccionado}
              editar={state.editar}
              codigo={state.id_usuario}
              handleOptionUser={handle_option_user}
            />
          </Row>
        </div>
      </Col>

      <Col xs={"12"} lg={"3"} className="prueba1">
        {/* { console.log(state.total_datos_estudiantes["id"])} */}
        <Info_registros
          id_estudiante={state.total_datos_estudiantes["id"]}
        ></Info_registros>
      </Col>

      <div class="d-block d-md-none col-12">
        <Col>
          <Selector
            id={state.id_usuario}
            actualizar={state.actualizar}
            rolUsuario={props.rolUsuario}
            datos={state.total_datos_estudiante_seleccionado}
            seleccionado={state.seleccionado}
            editar={state.editar}
            codigo={state.id_usuario}
            tab_abierto={state.tab_abierto}
            handleOptionUser={handle_option_user}
          />
        </Col>
      </div>

      <Modal show={show2} onHide={handleClose2} size={"lg"}>
        <Modal.Header closeButton>
          <Modal.Title>Importante</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!loading && fechas.length > 0 && Object.keys(riesgos).length > 0 && (
            <GraphComponent fechas={fechas} riesgos={riesgos} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Row>
  );
};

export default Info_basica;
